import React, { useEffect } from 'react'
import { Container, Image } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { UserManager } from 'oidc-client'
import tfbank21_logo_white from 'img/tf-logos/tfbank21-logo-white.svg'
import { appRoutes } from '../../constants/routes/Routes'
import { getClientSettings } from 'auth/services/auth.service'
import { setFullMobileViewHeight } from 'utils/helpers'
import { useNavigate } from 'react-router'
import { FooterLoggedOut } from 'components/Footer/Footer'

function LogoutCallbackPage() {
	setFullMobileViewHeight()

	const { t } = useTranslation()
	const logo = tfbank21_logo_white
	const navigate = useNavigate()

	useEffect(() => {
		logout()
	}, [])

	function logout() {
		const userManager = new UserManager(getClientSettings())

		userManager.signoutRedirectCallback().then(() => {
			sessionStorage.clear()
		})

		userManager.clearStaleState()
	}

	return (
		<div id="LogoutPage">
			<div className="login-page background-img">
				<div className="h-100 inner w-100 d-flex flex-column justify-content-between align-items-center">
					<Image
						src={logo}
						className="tfbank-logo login img-responsive mt-4"
						alt="TF Bank AB"
					/>
					<Container className="logoutBody">
						<h2 className="mb-4">{t('LoggedOut')}</h2>
						<button
							className="btn btn-outline light-gray"
							onClick={() => navigate(appRoutes.login)}>
							{t('Login')}{' '}
							<FontAwesomeIcon
								icon="sign-in-alt"
								className="ml-2"
							/>
						</button>
					</Container>
					<FooterLoggedOut />
				</div>
			</div>
		</div>
	)
}
export default LogoutCallbackPage